import { Navigate } from "react-router-dom";

const LoginProtected = ({children})=>{
const token = localStorage.getItem("token")
const role = localStorage.getItem("role")
console.log(token)
if(token===null){
    return children
}
return <Navigate to="/driver_forms/profile" />

}
export default LoginProtected